module.exports = __webpack_public_path__ + "media/images/sencillo-f3e342510a526b1e2e604675a01c5c2b.png";